/** @module csi/_base/EventTarget */
define([
	"dojo/_base/declare"
], function(declare) {

	/**
	 * @typedef {Object} MonitorEvent
	 * @property {Node} node - new version of node being monitored
	 * @property {string} type - either NODE_CHANGED or NODE_DELETED
	 */

	/**
	 * Simple implementation of EventTarget interface
	 */
	return declare(null, {
		listeners: null,

		constructor: function() {
			this.listeners = {};
		},

		addEventListener: function(type, callback) {
			const {listeners} = this;
			listeners[type] = listeners[type] || [];
			listeners[type].push(callback);
			// console.log("addEventListener: type=", type, "callback=", callback, "this=", this);
		},

		removeEventListener: function(type, callback) {
			const {listeners} = this;
			const stack = listeners[type];

			// console.log("removeEventListener: type=", type, "callback=", callback, "this=", this);
			if (!stack) {
				return;
			}

			for (var i = 0, l = stack.length; i < l; i++) {
				if (stack[i] === callback) {
					stack.splice(i, 1);
					break;
				}
			}

			if (!stack.length) {
				delete this.listeners[type];
			}

			if (!this.hasListeners()) {
				this._onDisconnect();
			}
		},

		dispatchEvent: function(event) {
			const {listeners} = this;
			const stack = listeners[event.type];

			if (!stack) {
				return true;
			}

			// copy stack as event listeners can be removed as they are called
			const stackCopy = [...stack];

			event.target = this;

			for (const listener of stackCopy) {
				listener.call(this, event);
			}

			return !event.defaultPrevented;
		},

		/**
		 * Returns true if there are any listeners
		 * @return {boolean}
		 */
		hasListeners: function() {
			const {listeners} = this;

			for (let type in listeners) {
				if (listeners[type].length > 0) {
					return true;
				}
			}
			return false;
		},

		/**
		 * Returns true if there are any listeners for the specified event type
		 * @param {string} type
		 * @return {boolean}
		 */
		hasListenersForType: function(type) {
			return (type in this.listeners);
		},

		/**
		 * Extension point called when last event listener removed
		 */
		onDisconnect: function() {},

		/**
		 * Called when the last event listener is removed
		 */
		_onDisconnect: function() {
			this.onDisconnect();
		}
	});
});